import React, { useState, useEffect } from 'react'
import { string } from 'prop-types'
import ButtonStandard from '@/component/Primitive/ButtonStandard'
import Icon from '@/component/Primitive/Icon'
import Type from '@/component/Primitive/Type'

const ShareButton = (props) => {
  const [shared, setShared] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const { label, labelShared, url } = props

  const handleShare = () => {
    if (!isClient) return

    // Copy URL to clipboard
    try {
      navigator.clipboard.writeText(url).then(() => {
        setShared(true)
        setTimeout(() => setShared(false), 2000)
      })
    } catch (err) {
      // Fallback for older browsers
      const textarea = document.createElement('textarea')
      textarea.value = url
      textarea.style.position = 'fixed' // Prevent scrolling to bottom
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()

      try {
        document.execCommand('copy')
        setShared(true)
        setTimeout(() => setShared(false), 2000)
      } catch (err) {
        console.error('Failed to copy URL: ', err)
      }

      document.body.removeChild(textarea)
    }
  }

  if (!isClient) return null

  return (
    <ButtonStandard onClick={handleShare} size="small">
      <Type size="body4" weight="medium" as="span">
        {!shared && (
          <>
            <Icon type="share" a11yText="" width={14} /> {label}
          </>
        )}
        {shared && (
          <>
            {labelShared || 'Copied!'}{' '}
            <Icon type="check" a11yText="" width={14} />
          </>
        )}
      </Type>
    </ButtonStandard>
  )
}

ShareButton.propTypes = {
  label: string.isRequired,
  labelShared: string,
  url: string.isRequired
}

export default ShareButton
